<template>
  <div class="mt-component-form">
    <vs-row class="my-4">
      <h5 v-if="title" style="align-self: center"><i class="dot"></i>{{title}}</h5>
      <!-- PC에서만 표시되는 버튼들 -->
      <div class="ml-auto hidden xl:flex">
        <vs-button
          v-if="!isPrint && !isReadonly"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow">항목추가</vs-button>
        <vs-button
          v-if="!isPrint && !isReadonly"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow">선택삭제</vs-button>
      </div>
      <!-- 모바일에서만 표시되는 버튼들 -->
      <div class="ml-auto xl:hidden">
        <vs-button
          v-if="!isPrint && !isReadonly"
          color="danger"
          type="border"
          @click="handleRemoveAllRows">전체삭제</vs-button>
      </div>
    </vs-row>

    <!-- PC 레이아웃 -->
    <div class="pc-layout" :class="onlyPc ? ['block'] : ['hidden', 'xl:block']">
      <div
        class="grid row-header border-left border-right"
        :style="isPrint || isReadonly ? 'grid-template-columns: 1fr 50px 50px 80px'
         : 'grid-template-columns: 50px 1fr 50px 50px 80px'"
      >
        <div v-if="!isPrint && !isReadonly" class="row-header__item">
          <vs-checkbox
            v-model="etcAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="row-header__item">{{getHeaderTitle}}</div>
        <div class="row-header__item border-left">{{getHeaderYes}}</div>
        <div class="row-header__item border-left">{{getHeaderNo}}</div>
        <div class="row-header__item border-left">{{getHeaderNa}}</div>
      </div>
      <!-- rows -->
      <div
        class="grid row-content border-left border-right"
        :style="isPrint || isReadonly ? 'grid-template-columns: 1fr 50px 50px 80px'
         : 'grid-template-columns: 50px 1fr 50px 50px 80px'"
        v-for="(rows, indexRows) in etcList"
        :key="indexRows"
      >
        <div v-if="!isPrint && !isReadonly" class="none-border-center">
          <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
        </div>
        <div class="item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.note"
                    class="w-full flex-1 p-1" :readonly="isReadonly"
                    @change="updateNote($event, indexRows, rows.note)"/>
          <span v-else class="print-input">{{ rows.note }}</span>
        </div>

        <!-- YES -->
        <div class="item-area center-flex border-left">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.checked === 'Yes'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :disabled="isReadonly"
            :checked="rows.checked === 'Yes'"
            @change="checkForm($event, indexRows, 'Yes')"
          ></vs-checkbox>
        </div>

        <!-- No -->
        <div class="item-area center-flex border-left">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.checked === 'No'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :disabled="isReadonly"
            :checked="rows.checked === 'No'"
            style="margin-right: 0"
            @change="checkForm($event, indexRows, 'No')"
          ></vs-checkbox>
        </div>

        <!-- N/A -->
        <div class="item-area center-flex border-left">
          <template v-if="isPrint">
            <div class="item-box-check" v-if="rows.checked === 'N/A'" style="text-align: center;  align-self: center;">
              <vs-icon icon="check" size="small"  ></vs-icon>
            </div>
            <div v-else class="item-box-check">
            </div>
          </template>
          <vs-checkbox
            v-else
            class="item-box-check"
            :disabled="isReadonly"
            :checked="rows.checked === 'N/A'"
            @change="checkForm($event, indexRows, 'N/A')"
          ></vs-checkbox>
        </div>
      </div>

      <!-- 빈 데이터 안내 (PC) -->
      <div v-if="!etcList || etcList.length === 0" class="grid row-content border-left border-right"
           :style="isPrint || isReadonly ? 'grid-template-columns: 1fr 50px 50px 80px' : 'grid-template-columns: 50px 1fr 50px 50px 80px'">
        <div class="col-span-full row-content-none-data">
          <p class="text-gray-500">등록된 점검 항목이 없습니다.</p>
        </div>
      </div>
    </div>

    <!-- 모바일 레이아웃 -->
    <div class="mobile-layout xl:hidden mt-4" :class="onlyPc ? ['hidden'] : ['block', 'xl:hidden']">
      <!-- 빈 데이터 안내 (모바일) -->
      <div v-if="!etcList || etcList.length === 0" class="empty-card">
        <p class="text-center text-gray-500">등록된 점검 항목이 없습니다.</p>
      </div>

      <ul v-else>
        <li v-for="(item, item_i) in etcList" :key="item_i" class="mobile-card">
          <!-- 항목 내용 -->
          <div class="card-content">
            <!-- 점검 내용 입력과 삭제 버튼 -->
            <div class="input-section-with-delete">
              <!-- 레이블과 삭제 버튼 -->
              <div class="label-with-delete">
                <label class="input-label">{{ getHeaderTitle }}</label>
                <button
                  v-if="!isPrint && !isReadonly"
                  type="button"
                  class="delete-btn-inline"
                  @click="handleRemoveSingleRow(item_i)"
                >
                  삭제
                </button>
              </div>
              <!-- 입력 폼 (전체 너비) -->
              <ml-input
                v-if="!isPrint"
                v-model="item.note"
                class="w-full"
                :readonly="isReadonly"
                placeholder="점검 내용을 입력하세요"
                @change="updateNote($event, item_i, item.note)"
              />
              <span v-else class="print-input">{{ item.note }}</span>
            </div>

            <!-- 체크박스 버튼 그룹 -->
            <div class="btn-container">
              <button
                type="button"
                :class="[item.checked === 'Yes' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'Yes')"
              >
                {{ getHeaderYes }}
              </button>
              <button
                type="button"
                :class="[item.checked === 'No' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'No')"
              >
                {{ getHeaderNo }}
              </button>
              <button
                type="button"
                :class="[item.checked === 'N/A' && 'active']"
                :disabled="isReadonly"
                @click="handleMobileCheck(item_i, 'N/A')"
              >
                {{ getHeaderNa }}
              </button>
            </div>
          </div>
        </li>
      </ul>

      <!-- 모바일 하단 추가 버튼 -->
      <div v-if="!isPrint && !isReadonly" class="mobile-footer">
        <button type="button" class="add-btn" @click="handleAddRow">
          <vs-icon icon="add" size="small"></vs-icon>
          항목 추가
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableEtcCheck',
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    onlyPc: {
      type: Boolean,
      default: false,
    },
    title: String,
    tableHeaderTitle: String,
    tableHeaderYes: String,
    tableHeaderNo: String,
    tableHeaderNa: String,
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.etcList = value
        }
      },
    },
  },
  computed: {
    getHeaderTitle () {
      if (this.tableHeaderTitle) return this.tableHeaderTitle
      else return '점검내용'
    },
    getHeaderYes () {
      if (this.tableHeaderYes) return this.tableHeaderYes
      else return 'Yes'
    },
    getHeaderNo () {
      if (this.tableHeaderNo) return this.tableHeaderNo
      else return 'No'
    },
    getHeaderNa () {
      if (this.tableHeaderNa) return this.tableHeaderNa
      else return 'N/A'
    },
  },
  methods: {
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows, text)
      } else {
        this.$emit('update-list-check', indexRows, '')
      }
    },

    handleMobileCheck(index, value) {
      if (this.isReadonly) return;

      // 모바일에서 체크박스 클릭 시 emit 발생
      this.$emit('update-list-check', index, value);
    },

    // 항목추가
    handleAddRow () {
      this.etcList.push({
        is_checked: this.etcAllCheck,
        note: '',
        checked: '',
      })
      this.updateList()
    },

    // 선택삭제
    handleRemoveRow () {
      for (let i = this.etcList.length - 1; i >= 0; i--) {
        if (this.etcList[i].is_checked) {
          this.etcList.splice(i, 1)
        }
      }

      this.etcAllCheck = false
      this.updateList()
    },

    // 단일 항목 삭제 (모바일용)
    handleRemoveSingleRow (index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '항목 삭제',
        text: '이 항목을 삭제하시겠습니까?',
        acceptText: '확인',
        cancelText: '취소',
        accept: () => {
          this.etcList.splice(index, 1)
          this.updateList()
        }
      })
    },

    // 전체 삭제 (모바일용)
    handleRemoveAllRows () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '전체 삭제',
        text: '모든 항목을 삭제하시겠습니까?',
        acceptText: '확인',
        cancelText: '취소',
        accept: () => {
          this.etcList = []
          this.etcAllCheck = false
          this.updateList()
        }
      })
    },

    // 일괄 체크
    changeAllCheck () {
      for (const data of this.etcList) {
        data.is_checked = this.etcAllCheck
      }
    },
    // update
    updateList () {
      this.$emit('updateList', this.etcList)
    },
    updateNote (value, indexRows, text) {
      this.$emit('update-note', indexRows, text)
    }
  },
  data () {
    return {
      etcAllCheck: false,
      etcList: [],
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 모바일 레이아웃 스타일 */
.mobile-layout {
  .empty-card {
    border: 1px solid #cdcdcd;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background-color: #f9f9f9;
  }

  ul {
    margin-top: 0;

    li.mobile-card {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #cdcdcd;
      border-radius: 8px;
      margin-bottom: 12px;
      padding: 20px;

      &:first-child {
        border-radius: 8px;
      }

      .card-content {
        .input-section-with-delete {
          margin-bottom: 16px;

          .label-with-delete {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;

            .input-label {
              font-weight: 600;
              color: #2c2c2c;
              margin: 0;
            }

            .delete-btn-inline {
              background: #ff4757;
              color: white;
              border: none;
              border-radius: 6px;
              padding: 6px 12px;
              font-size: 12px;
              font-weight: 500;
              cursor: pointer;
              min-height: 32px;
              flex-shrink: 0;
              transition: all 0.2s ease;

              &:hover {
                background: #e84343;
              }
            }
          }
        }

        .btn-container {
          display: flex;
          align-items: center;
          border: 1px solid #cdcdcd;
          border-radius: 8px;
          overflow: hidden;

          button {
            flex: 1;
            font-family: "Noto Sans KR";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #2c2c2c;
            background: none;
            border: 0;
            border-right: 1px solid #cdcdcd;
            outline: 0;
            padding: 12px 8px;
            min-height: 44px; // 터치 친화적 최소 높이
            cursor: pointer;
            transition: all 0.2s ease;

            &:last-child {
              border-right: 0;
            }

            &:hover:not(:disabled) {
              background-color: #f5f5f5;
            }

            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }

            &.active {
              color: white;
              background: #200c63;

              &:hover {
                background: #1a0a52;
              }
            }
          }
        }
      }
    }
  }

  .mobile-footer {
    margin-top: 16px;
    padding: 16px 0;

    .add-btn {
      width: 100%;
      background: #200c63;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 14px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      &:hover {
        background: #1a0a52;
      }

      .vs-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 반응형 클래스 */
@media (max-width: 1279px) {
  .pc-layout {
    display: none !important;
  }

  .mobile-layout {
    display: block !important;
  }
}

@media (min-width: 1280px) {
  .pc-layout {
    display: block !important;
  }

  .mobile-layout {
    display: none !important;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .pc-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }
}
</style>
